import { Component, OnInit, inject } from '@angular/core';
import { FormMigRequest } from '@models/account/forms/form-request.model';
import { IMigFormService } from '../../services/mig-form.service';
import { Resident } from '@models/account/resident.model';
import { ResidentFormsComponent } from '@components/abstract/resident-forms.component';
import { alertFire } from '@functions/alerts';
import { createUrlTreeFromSnapshot } from '@angular/router';
import { merge } from 'rxjs';

@Component({
  selector: 'app-form-page',
  templateUrl: './form-page.component.html',
  styleUrls: ['./form-page.component.scss'],
})
export class FormPageComponent
  extends ResidentFormsComponent
  implements OnInit
{
  module = inject(IMigFormService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.module.step = 4;
    this.unsubscribe.push(
      merge(this.module.form$, this.module.sections$).subscribe(() => {
        if (this.module.form$.value && this.module.sections$.value) {
          this.model = this.module.form$.value;
          this.resident = this.module.user$.value as Resident;
          this.subscribe(this.module.sections$.value);
        }
      })
    );
    this.unsubscribe.push(
      this.module.onSubmit.subscribe(() => {
        this.ngSubmit();
      })
    );
    this.unsubscribe.push(
      this.module.onPrevious.subscribe(() => {
        const urlTree = createUrlTreeFromSnapshot(this.route.snapshot, ['../']);
        this.router.navigateByUrl(urlTree).then();
      })
    );
  }

  ngSubmit() {
    let params = this.params as FormMigRequest;
    if (this.form.status === 'INVALID') {
      this.toastr.error('Error. Invalid fields.');
    } else {
      alertFire('This action cannot be undone!').then(result => {
        if (result.value) {
          const storage = this.module.storage;
          if (storage) {
            params = {
              ...params,
              fillerName: storage.name,
              fillerEmail: storage.email,
              checkMigForm: true,
            };
          }
          this.api
            .post(`users/${this.resident.id}/responses-save`, params)
            .subscribe({
              next: () => {
                this.toastr.success('Saved Successfully.');
                this.router
                  .navigate([
                    '/mig-form',
                    this.module.corporation$.value?.code,
                    'congratulations',
                    this.resident.id,
                  ])
                  .then();
              },
              error: () => {
                this.toastr.error(
                  'An error occurred on save. Try again in a few seconds.'
                );
              },
            });
        }
      });
    }
  }
}
